import RestService from '../services/rest';

async function getDetailOrder(startDate, endDate, orderNumber = '') {
  return RestService.getAuthenticated(
    `returnPickingOrder/DetailOrder?filterStartDate=${startDate}&filterEndDate=${endDate}&orderNumber=${orderNumber}`,
  );
}

async function getDataGrid(tableParams) {
  return RestService.postAuthenticated('returnPickingOrder/list', tableParams);
}

async function createPickingReturnDocument(
  outboundProducts,
  outboundOrderId,
  orderNumber,
  branchCode,
  sendIntegration,
) {
  return RestService.putAuthenticated('returnPickingOrder/createDocument', {
    outboundProducts,
    outboundOrderId,
    orderNumber,
    branchCode,
    sendIntegration,
  });
}

export default {
  getDataGrid,
  getDetailOrder,
  createPickingReturnDocument,
};
